import { LocationUserAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * A page of the locations an identity can access, display-ready.
 *
 * @param {Object} params - See `clients/GetIdentityLocations`.
 * @returns {Promise<import('../types/User').IGetIdentityLocationsPageResult>}
 */
export const getIdentityLocations = async (params) => {
  const response = await UsersApi.getIdentityLocations(params);

  return LocationUserAdapters.toIdentityLocationsPageResult(response);
};
